var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-63ab709d\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MentoringBoyIcon.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/boy/MentoringBoyIcon.vue
// module id = a0124e718a473d7cab14
// module chunks = 89